import React from "react";
import { hrGuideSections } from "../../data/hrGuideContent";

export default function HRGuideModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[1000] p-4">
      <div className="bg-white dark:bg-neutral-900 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden border border-gray-200 dark:border-neutral-700">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-neutral-700">
          <div>
            <h2 className="text-2xl font-bold">HR Module Guide</h2>
            <p className="text-sm text-gray-500">
              Overview of implemented features, structure and usage.
            </p>
          </div>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black dark:hover:text-white text-xl"
          >
            ✕
          </button>
        </div>

        <div className="px-6 py-5 overflow-y-auto max-h-[calc(90vh-90px)] space-y-6">
          {hrGuideSections.map((section, index) => (
            <div
              key={section.title}
              className="border border-gray-200 dark:border-neutral-700 rounded-xl p-4"
            >
              <div className="text-sm text-gray-400 mb-1">
                Section {index + 1}
              </div>
              <h3 className="text-lg font-semibold mb-2">{section.title}</h3>
              <p className="text-sm leading-6 text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                {section.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}